import { LookupResponse } from '@core/models/common.model';

// The Metadata of a lookup item (a JSON object, sent as text by the generic lookups endpoint), or null when it has none.
export function lookupMetadata<T extends object>(item: LookupResponse | null | undefined): T | null {
  if (!item?.metadata) {
    return null;
  }

  try {
    return JSON.parse(item.metadata) as T;
  } catch {
    return null;
  }
}
